import React, { useState, useContext, useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { ChannelContext, CommonContext } from '../../context';
import { CardHeader, Tabs, Tab } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import commonApi from '../../utils/api';
import { AppUrl } from '../../utils/config';

const AddChannel = () => {
    const { user } = useContext(CommonContext);
    const {
        addModal,
        handleCloseModal,
        setIsLoading,
        viewData,
        onLoadApi,
        isEdit,
        setOpenAlert,
        setAlertMesaage,
        setSeverity,
        setIsEdit,
    } = useContext(ChannelContext);

    const [formErrors, setFormErrors] = useState({});
    const [formData, setFormData] = useState({
        channel_type_id: '',
        channel_name: '',
        shopify_app_token: '',
        shopify_store_name: '',
        status: 1, // Default to Active
    });
    const [tabValue, setTabValue] = useState(0);


    useEffect(() => {
        if (tabValue === 0) {
            setFormData({ ...formData, channel_type_id: 1 });
        } else if (tabValue === 1) {
            setFormData({ ...formData, channel_type_id: 2 });
        }
    }, [tabValue]);
    useEffect(() => {
        if (viewData) {
            setFormData(viewData[0]);
            setTabValue(viewData[0].channel_type_id - 1);
        }
        // else {
        //     setFormData({
        //         channel_type_id: '',
        //         channel_name: '',
        //         shopify_app_token: '',
        //         shopify_store_name: '',
        //         status: 1,
        //     });
        // }
    }, [viewData]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = {};

        // Shopify validation
        if (tabValue === 0) {
            if (!formData.channel_name) errors.channel_name = 'Channel name is required';
            // if (!formData.shopify_app_token) errors.shopify_app_token = 'App Token is required';
            // if (!formData.shopify_store_name) errors.shopify_store_name = 'Store Name is required';
        }

        setFormErrors(errors);
        if (user?.user_type === "Merchant") {
            formData.merchant_id = user?.id
        }
        if (Object.keys(errors).length === 0) {
            setIsLoading(true);
            const url = isEdit ? 'channel-integration/edit-channel-setup' : 'channel-integration/create-channel-setup';
            commonApi.post(url, formData)
                .then((response) => {
                    setIsEdit(false);
                    setIsLoading(false);
                    setOpenAlert(true);
                    setAlertMesaage(response?.data?.message);
                    setSeverity(response.data.s === 1 ? 'success' : 'error');
                    onLoadApi();
                    handleCloseModal();
                })
                .catch((error) => {
                    setIsEdit(false);
                    setIsLoading(false);
                    setOpenAlert(true);
                    setAlertMesaage(error?.response?.data?.message);
                    setSeverity('error');
                });
        }
    };

    return (
        <Modal open={addModal} onClose={handleCloseModal}>
            <Container className={'formContainer'}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <CardHeader sx={{ padding: '0' }} title={`${isEdit ? 'Edit' : 'Add'} Channel`} />
                    <IconButton onClick={handleCloseModal}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="channel tabs">
                    <Tab label="Shopify" />
                    <Tab label="Woocommerce" />
                </Tabs>
                <form onSubmit={handleSubmit}>
                    {/* {tabValue === 0 && ( */}
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={'paper'}>
                                <div className={'column-form'}>
                                    <TextField
                                        className="custom-input"
                                        label="Channel Name *"
                                        name="channel_name"
                                        value={formData.channel_name}
                                        onChange={handleChange}
                                        error={!!formErrors.channel_name}
                                        helperText={formErrors.channel_name}
                                        fullWidth
                                    />
                                    <TextField
                                        className="custom-input"
                                        label="App Token"
                                        name="shopify_app_token"
                                        value={formData.shopify_app_token}
                                        onChange={handleChange}
                                        error={!!formErrors.shopify_app_token}
                                        helperText={formErrors.shopify_app_token}
                                        fullWidth
                                    />
                                    <TextField
                                        className="custom-input"
                                        label="Store Name"
                                        name="shopify_store_name"
                                        value={formData.shopify_store_name}
                                        onChange={handleChange}
                                        error={!!formErrors.shopify_store_name}
                                        helperText={formErrors.shopify_store_name}
                                        fullWidth
                                    />
                                    <FormControl component="fieldset" fullWidth margin="normal">
                                        <RadioGroup
                                            row
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <FormControlLabel
                                                value={1}
                                                control={<Radio />}
                                                label="Active"
                                            />
                                            <FormControlLabel
                                                value={0}
                                                control={<Radio />}
                                                label="Inactive"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                    {/* )} */}
                    <Box sx={{ width: '100%', textAlign: 'right', marginTop: '2rem' }}>
                        <Button variant="contained" color="primary" type="submit">
                            Submit
                        </Button>
                    </Box>
                </form>
            </Container>
        </Modal>
    );
};

export default AddChannel;
